import React from 'react';
import { mockData } from '../mock';
import { useContent } from '../context/ContentContext';
import { useTheme } from '../context/ThemeContext';

const COLORFUL_LOGO_FILL = 'linear-gradient(90deg, #ff3b30 0%, #ff9500 18%, #ffe500 36%, #36c95a 55%, #168cff 76%, #a13de0 100%)';

const Logo = ({ size = 'md', variant = 'stacked' }) => {
  const { content } = useContent();
  const { theme, activeTheme } = useTheme();
  const heights = variant === 'wide'
    ? { sm: 'h-5 md:h-8', md: 'h-10 md:h-12', lg: 'h-14 md:h-20', xl: 'h-16 md:h-24' }
    : { sm: 'h-11', md: 'h-20', lg: 'h-32 md:h-44', xl: 'h-40 md:h-56 lg:h-72' };
  const customLogo = variant === 'wide'
    ? activeTheme?.logoWideImage || activeTheme?.logoImage
    : activeTheme?.logoImage || activeTheme?.logoWideImage;
  const logoSrc = customLogo || content.site?.logoImage || (variant === 'wide' ? mockData.refuelLogoWide : mockData.refuelLogo);
  const logoFill = !!activeTheme && theme !== 'original' && theme !== 'light' && !customLogo;
  const logoBackground = theme === 'colorful' ? COLORFUL_LOGO_FILL : activeTheme?.color;
  return (
    <span className="relative inline-flex" data-theme-logo={theme}>
      <img
        src={logoSrc}
        alt="Refuel Weekend logo"
        data-testid={`refuel-logo-${size}`}
        className={`${heights[size]} w-auto select-none drop-shadow-[0_0_24px_rgba(255,46,46,0.35)] ${logoFill ? 'opacity-0' : ''}`}
        draggable={false}
      />
      {logoFill && (
        <span
          className={`${heights[size]} pointer-events-none absolute inset-0 w-full theme-logo-color`}
          aria-hidden="true"
          style={{
            background: logoBackground,
            maskImage: `url("${logoSrc}")`,
            WebkitMaskImage: `url("${logoSrc}")`,
            maskMode: 'alpha',
            maskRepeat: 'no-repeat',
            WebkitMaskRepeat: 'no-repeat',
            maskPosition: 'center',
            WebkitMaskPosition: 'center',
            maskSize: '100% 100%',
            WebkitMaskSize: '100% 100%',
          }}
        />
      )}
    </span>
  );
};

export default Logo;
